import { LeftOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import winitechLogo from "../../assets/winitechLogo.jpg";
import shortcutLogo from "../../assets/winitech_icon.png";
import {
  KEY_MENU_WORK_MANAGEMENT,
  MENU_WORK_MANAGEMENT,
} from "../../config/Constant";
import { useSideBarStore } from "../../store/SideBarStore";
import { useInfoUser } from "../../store/UserStore";
import "./style.scss";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

const WorkManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { languageMap } = useInfoUser();
  const [chosedMenuItem, setChosedMenuItem] = useState(
    KEY_MENU_WORK_MANAGEMENT.DASHBOARD
  );
  const { switchIsWorkManagementOptions, isWorkManagementOptions } =
    useSideBarStore((state) => state);
  const [workManagementHeight, setWorkManagementHeight] = useState(
    window.innerHeight
  );
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleMenuItemClick = (menuItem) => {
    navigation(menuItem);
    switchIsWorkManagementOptions();
    setChosedMenuItem(menuItem);
  };

  const navigation = (menuItem) => {
    switch (menuItem) {
      case KEY_MENU_WORK_MANAGEMENT.NEW_PROJECT:
        return navigate("/work-management/project");
      case KEY_MENU_WORK_MANAGEMENT.DASHBOARD:
        return navigate("/work-management/dashboard");
      case KEY_MENU_WORK_MANAGEMENT.TIMELINE:
        return navigate("/work-management/timeline");
      case KEY_MENU_WORK_MANAGEMENT.CALENDAR:
        return navigate("/work-management/calendar");
      case KEY_MENU_WORK_MANAGEMENT.ALARM:
        return navigate("/work-management/alarm");
      case KEY_MENU_WORK_MANAGEMENT.TASK:
        return navigate("/work-management/task");
      // case KEY_MENU_WORK_MANAGEMENT.FILE:
      //   return navigate("/work-management/");
      default:
        return navigate("/work-management/dashboard");
    }
  };

  const generateWorkMenu = (item) => {
    return (
      <div
        className={
          chosedMenuItem === item?.key
            ? "conversation bg-[#daeaff]"
            : "conversation"
        }
        onClick={() => {
          handleMenuItemClick(item?.key);
        }}
        key={item.key}
      >
        <div className="w-[100%]">
          <div className="menu-item">
            {item?.icon}
            {(!toggleMenu || isMobile) && (
              <div className="name">
                {languageMap?.[
                  `event.tab.${item?.name.toLowerCase().replace(" ", "_")}`
                ] ?? item?.name}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const calculateWorkManagementHeight = () => {
    setWorkManagementHeight(windowHeight);
  };

  const setMenuItemBasedOnPath = (location) => {
    const path = location.pathname;
    const menuItems = {
      "/work-management/dashboard": KEY_MENU_WORK_MANAGEMENT.DASHBOARD,
      "/work-management/task": KEY_MENU_WORK_MANAGEMENT.TASK,
      "/work-management/alarm": KEY_MENU_WORK_MANAGEMENT.ALARM,
    };

    setChosedMenuItem(menuItems[path]);
  };

  useEffect(() => {
    setMenuItemBasedOnPath(location);

    const handleResize = () => {
      setIsMobile(window.innerWidth < 930);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    calculateWorkManagementHeight();
  }, [windowHeight]);

  return (
    <>
      {!isMobile ? (
        <div className="desktop-work-management-menu">
          <div className="flex overflow-hidden">
            <div
              className={`work-management-menu transition-all duration-300 ${toggleMenu ? "!w-[40px]" : "!w-[300px]"}`}
            >
              {toggleMenu ? (
                <div
                  className="expanded cursor-pointer"
                  onClick={() => {
                    setToggleMenu(!toggleMenu);
                  }}
                >
                  <MdOutlineKeyboardArrowRight size={14} />
                </div>
              ) : (
                <div
                  className="compact cursor-pointer"
                  onClick={() => {
                    setToggleMenu(!toggleMenu);
                  }}
                >
                  <MdOutlineKeyboardArrowLeft size={14} />
                </div>
              )}

              <div className="work-management-list">
                <div
                  className="work-management-container"
                  style={{
                    maxHeight: `${workManagementHeight}px`,
                  }}
                  id="work-management-container"
                >
                  <img
                    className={`cursor-pointer ${toggleMenu ? "p-[10px]" : ""}`}
                    onClick={() => {
                      setToggleMenu(!toggleMenu);
                    }}
                    src={toggleMenu ? shortcutLogo : winitechLogo}
                    alt="logo"
                  />
                  {MENU_WORK_MANAGEMENT.map((item) => generateWorkMenu(item))}
                </div>
              </div>
            </div>
            <div className="work-content ml-[16px] h-[100vh] overflow-y-auto bg-white">
              <Outlet />
            </div>
          </div>
        </div>
      ) : (
        <div className="mobile-work-management-menu">
          <div className="flex overflow-hidden">
            <div
              className={`work-management-menu ${isWorkManagementOptions ? "block" : "hidden"}`}
            >
              <div className="work-management-list">
                <div
                  className="work-management-container"
                  style={{
                    maxHeight: `${workManagementHeight}px`,
                  }}
                >
                  <div className="flex justify-around items-center">
                    <a
                      className="btn-back-to-work-management"
                      onClick={() => navigate("/conversation")}
                    >
                      <LeftOutlined size={25} />
                    </a>
                    <img src={winitechLogo} alt="" className="max-h-[80px]" />
                    <span></span>
                  </div>
                  {MENU_WORK_MANAGEMENT.map((item) => generateWorkMenu(item))}
                </div>
              </div>
            </div>
            <div
              className={`work-content h-[100vh] overflow-y-auto bg-white ${isWorkManagementOptions ? "hidden" : "block"}`}
            >
              <Outlet />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default WorkManagement;
